import { z } from 'zod'

export const rebalancingTargetSchema = z.object({
  instrumentUid: z.string().min(1),
  figi: z.string().nullable().optional(),
  ticker: z.string().nullable().optional(),
  instrumentName: z.string().nullable().optional(),
  targetPercent: z.number().min(0).max(100),
})

export type RebalancingTargetDto = z.infer<typeof rebalancingTargetSchema>

export const setRebalancingTargetsSchema = z.object({
  targets: z.array(rebalancingTargetSchema),
})

export type SetRebalancingTargetsDto = z.infer<typeof setRebalancingTargetsSchema>

export const rebalancingTargetResponseSchema = z.object({
  instrumentUid: z.string(),
  figi: z.string().nullable(),
  ticker: z.string().nullable(),
  instrumentName: z.string().nullable(),
  targetPercent: z.number(),
})

export type RebalancingTargetResponseDto = z.infer<typeof rebalancingTargetResponseSchema>
